import { render } from "./AccettazioneContratti.vue?vue&type=template&id=a590b17a&scoped=true"
import script from "./AccettazioneContratti.vue?vue&type=script&lang=js"
export * from "./AccettazioneContratti.vue?vue&type=script&lang=js"

import "./AccettazioneContratti.vue?vue&type=style&index=0&id=a590b17a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a590b17a"]])

export default __exports__